import FRCallback from './index.js';

/*
 * @forgerock/javascript-sdk
 *
 * polling-wait-callback.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/**
 * Represents a callback used to instruct the system to poll while a backend process completes.
 */
class PollingWaitCallback extends FRCallback {
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the message to display while polling.
     */
    getMessage() {
        return this.getOutputByName('message', '');
    }
    /**
     * Gets the polling interval in milliseconds.
     */
    getWaitTime() {
        return Number(this.getOutputByName('waitTime', 0));
    }
}

export { PollingWaitCallback as default };
